import React, { FC, MouseEvent, useState } from 'react'

import MenuIcon from '@mui/icons-material/Menu'
import { Menu, MenuItem } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { ToolbarPropsOverrides } from '@mui/x-data-grid'
import { GridToolbarProps } from '@mui/x-data-grid/components/toolbar'

import { AddAccountModal } from 'components/bots/accounts/AddAccountModal/index'
import TableToolbar from 'components/table/TableToolbar/index'

import { AccountsTabActions } from 'pages/bots/AccountsTab/index'

interface Props extends Partial<GridToolbarProps & ToolbarPropsOverrides> {
  modal: AccountsTabActions
  setModal: React.Dispatch<React.SetStateAction<AccountsTabActions>>
  singleRow: any
}

export const AccountsBotsTableToolbar: FC<Props> = ({
  searchValue,
  onSearchChange,
  modal,
  setModal,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>()
  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <TableToolbar
        onChange={onSearchChange}
        searchValue={searchValue}
        rightContent={
          <Box>
            <Button size="small" startIcon={<MenuIcon />} onClick={handleOpenMenu}>
              Actions
            </Button>
            <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center' }}>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-toolbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={!!anchorEl}
                onClose={handleCloseMenu}
              >
                <MenuItem
                  onClick={() => {
                    setModal('ADD')
                    handleCloseMenu()
                  }}
                >
                  <Typography textAlign="center">Add Account</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        }
      />
      {modal === 'ADD' && (
        <AddAccountModal
          onCLose={() => {
            setModal('')
          }}
        />
      )}
    </>
  )
}
